import { useState, useEffect } from "react";
import CloseIcon from "../icons/AikaIcons/CloseIcon";
import IconNotSmallScreens from "../icons/IconNotSmallScreens";

export default function SmallScreenWarningModal() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 821);

  const handleClose = () => {
    setIsSmallScreen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 821);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isSmallScreen ? (
    <div
      className="c-modal-overlay c-modal-overlay--sm vw-100 vh-100"
      style={{ zIndex: 2000 }}
    >
      <dialog className="c-modal">
        <button className="btn btn-circle ms-auto" onClick={handleClose}>
          <CloseIcon />
        </button>
        <div
          className="d-flex flex-column align-items-center"
          style={{ maxWidth: 360 }}
        >
          <span className="mt-n4 mb-3">
            <IconNotSmallScreens height={100} />
          </span>
          <h3 className=" h4 mb-3 lh-sm text-center">
            Indberetningsportalen fungerer ikke optimalt på små skærme
          </h3>
          <p className="text-center">
            Vi anbefaler, at du besøger siden fra en computer for den bedste
            oplevelse.
          </p>
        </div>
      </dialog>
    </div>
  ) : null;
}
